// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_OF_USER = "Profil pou\u017e\u00edvate\u013eky";
